import * as React from "react";
const SvgWizardFieldFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 64, height: 64, viewBox: "0 0 64 64", fill: "none", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 4, y: 20, width: 56, height: 24, rx: 4, fill: "#F1ECF1" }), /* @__PURE__ */ React.createElement("rect", { x: 4, y: 42, width: 56, height: 2, fill: "currentColor" }));
export default SvgWizardFieldFilled;
